var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInativo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "inativo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.857,
    height: 14.857,
    viewBox: "0 0 14.857 14.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1397",
    "data-name": "Caminho 1397",
    d: "M11.143,1.238a2.479,2.479,0,0,1,2.476,2.476v7.429a2.479,2.479,0,0,1-2.476,2.476H3.714a2.479,2.479,0,0,1-2.476-2.476V3.714A2.479,2.479,0,0,1,3.714,1.238Zm0-1.238H3.714A3.714,3.714,0,0,0,0,3.714v7.429a3.714,3.714,0,0,0,3.714,3.714h7.429a3.714,3.714,0,0,0,3.714-3.714V3.714A3.714,3.714,0,0,0,11.143,0Z",
    fill: "#d93944"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1398",
    "data-name": "Caminho 1398",
    d: "M11.147,10.272,12.9,8.521a.619.619,0,1,0-.875-.875L10.272,9.4,8.521,7.645a.619.619,0,0,0-.875.875L9.4,10.272,7.646,12.023a.619.619,0,1,0,.875.875l1.751-1.751L12.023,12.9a.619.619,0,1,0,.875-.875Z",
    transform: "translate(-2.843 -2.843)",
    fill: "#d93944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInativo);
export default __webpack_public_path__ + "static/media/inativo.51525db9e54fcab0fe8244e26ad7c3f1.svg";
export { ForwardRef as ReactComponent };